// extracted by mini-css-extract-plugin
export default {"wrap":"nF-z","fullWidth":"oF-z","hideOnDesktop":"pF-z","content":"qF-z","hasOpenedNav":"rF-z","crumbsList":"sF-z","dropdownsWrap":"tF-z"};